<template>
  <div class="left-sidebar">
    <div v-if="ticket" class="active-ticket-card">
      <div class="ticket-card-body">
        <div class="ticket-header-section">
          <div class="ticket-header-card" @click="toggleTicketHeader">
            <div class="ticket-header-main">
              <div class="ticket-title-row">
                <i
                  :class="[
                    'mdi chevron-icon',
                    isTicketHeaderExpanded
                      ? 'mdi-chevron-down'
                      : 'mdi-chevron-right',
                  ]"
                ></i>
                <h4 class="ticket-full-title">
                  #{{ ticket.ticketId }} – {{ ticket.ticketName }}
                </h4>
              </div>
              <button
                class="copy-ticket-btn"
                @click.stop="copyTicketName"
                title="Копіювати назву тікету"
              >
                <i class="mdi mdi-content-copy"></i>
              </button>
            </div>
            <div v-if="isTicketHeaderExpanded" class="ticket-meta">
              <i class="mdi mdi-calendar-clock"></i>
              <span>Дата створення: {{ ticket.createDatetime }}</span>
            </div>
          </div>
        </div>

        <TicketInfoSection
          :ticket="ticket"
          :expanded="expandedSections.about"
          @toggle="(val) => updateSection('about', val)"
        />

        <ClientsMiniList
          :clients="ticket.userPhones || []"
          :ticketId="ticket.ticketId"
          @phone-click="(phone) => $emit('phone-click', phone)"
          @add-phone="(phoneData) => $emit('add-phone', phoneData)"
          @delete-phone="(data) => $emit('delete-phone', data)"
          @repeat-appeal="(number) => $emit('repeat-appeal', number)"
          @view-appeals="(number) => $emit('view-appeals', number)"
        />

        <NotifyPhonesList
          :clients="ticket.userPhones || []"
          :ticketId="ticket.ticketId"
          :savedNotifyPhones="ticket.notifyPhones || null"
          @update-notify-phones="(phones) => $emit('update-notify-phones', phones)"
        />

        <AssignedUsersList
          :assigned-workers="ticket.assignedWorkers || []"
          :can-manage="canManageUsers"
          @add-assigned-user="(workers) => $emit('add-assigned-user', workers)"
          @remove-assigned-user="(worker) => $emit('remove-assigned-user', worker)"
        />

        <ExecutorsList
          :in-job-workers="ticket.inJobWorkers || []"
          :can-manage="canManageUsers"
          @add-executor="$emit('add-executor')"
          @remove-executor="(worker) => $emit('remove-executor', worker)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TicketInfoSection from "./TicketInfoSection.vue";
import ClientsMiniList from "./ClientsMiniList.vue";
import NotifyPhonesList from "./NotifyPhonesList.vue";
import AssignedUsersList from "./AssignedUsersList.vue";
import ExecutorsList from "./ExecutorsList.vue";

export default {
  name: "LeftSidebar",
  components: {
    TicketInfoSection,
    NotifyPhonesList,
    ClientsMiniList,
    AssignedUsersList,
    ExecutorsList,
  },
  props: {
    ticket: {
      type: Object,
      default: null,
    },
    expandedSections: {
      type: Object,
      default: () => ({
        about: true,
        clients: false,
      }),
    },
  },
  emits: [
    "update-sections",
    "phone-click",
    "add-phone",
    "delete-phone",
    "repeat-appeal",
    "view-appeals",
    "update-notify-phones",
    "add-assigned-user",
    "remove-assigned-user",
    "add-executor",
    "remove-executor",
  ],
  data() {
    return {
      isTicketHeaderExpanded: true,
    };
  },
  computed: {
    canManageUsers() {
      // TODO: Add permission check logic here
      // For now, return true
      return true;
    },
  },
  methods: {
    toggleTicketHeader() {
      this.isTicketHeaderExpanded = !this.isTicketHeaderExpanded;
    },
    copyTicketName() {
      const ticketInfo = `#${this.ticket.ticketId} - ${this.ticket.ticketName}`;
      navigator.clipboard.writeText(ticketInfo).then(() => {
        this.$toast.success("Назву тікету скопійовано");
      });
    },
    updateSection(section, value) {
      this.$emit("update-sections", { section, value });
    },
  },
};
</script>

<style scoped>
.left-sidebar {
  width: 280px;
  background: #f8f9fa;
  border-right: 1px solid #e9ecef;
  overflow-y: auto;
  flex-shrink: 0;
}

.active-ticket-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ticket-card-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.ticket-header-section {
  /* margin-bottom: 16px; */
  /* margin: -16px -16px 16px -16px; */
  margin: 0px -6px 10px;
}

.ticket-header-card {
  background: linear-gradient(135deg, #5e9cec 0%, #4a89dc 100%);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(94, 156, 236, 0.2);
}

.ticket-header-card:hover {
  box-shadow: 0 4px 12px rgba(94, 156, 236, 0.3);
  transform: translateY(-1px);
}

.ticket-header-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  justify-content: space-between;
}

.ticket-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.chevron-icon {
  font-size: 18px;
  color: white;
  flex-shrink: 0;
  margin-top: 2px;
  opacity: 0.9;
}

.ticket-full-title {
  font-size: 15px;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.copy-ticket-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
}

.copy-ticket-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.08);
}

.copy-ticket-btn i {
  font-size: 16px;
  color: white;
}

.ticket-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  animation: slideDown 0.2s ease-out;
}

.ticket-meta i {
  font-size: 14px;
  opacity: 0.9;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1200px) {
  .left-sidebar {
    width: 240px;
  }
}

@media (max-width: 992px) {
  .left-sidebar {
    width: 100%;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid #e9ecef;
  }
}

@media (max-width: 768px) {
  .left-sidebar {
    max-height: 150px;
  }

  .ticket-header-card {
    padding: 14px;
    border-radius: 10px;
  }

  .ticket-full-title {
    font-size: 14px;
  }

  .chevron-icon {
    font-size: 16px;
  }

  .copy-ticket-btn {
    width: 28px;
    height: 28px;
  }

  .copy-ticket-btn i {
    font-size: 14px;
  }

  .ticket-meta {
    font-size: 11px;
    margin-top: 10px;
    padding-top: 10px;
  }

  .ticket-meta i {
    font-size: 12px;
  }

  .ticket-card-body {
    padding: 12px;
  }
}

@media (max-width: 576px) {
  .left-sidebar {
    width: 100%;
    max-height: none;
  }
}

@media (max-width: 768px) and (orientation: landscape) {
  .left-sidebar {
    width: 220px;
    max-height: none;
    border-right: 1px solid #e9ecef;
    border-bottom: none;
  }
}
</style>
